import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import { CompetitionApi, SiteConfigManager, useSettings } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import Competition from 'components/Tournament/Competition';
import { CompetitionsProvider } from 'components/Tournament/context/context';
import Tournament from 'components/Tournament/Tournament';

const { PROMOTION_TOURNAMENTS } = COMPONENT_TYPES;

const TournamentRouter = () => {
  const { lang } = useSettings();
  const [competitions, setCompetitions] = useState([]);

  const competitionPath = SiteConfigManager.getComponentPath(PROMOTION_TOURNAMENTS);

  useEffect(() => {
    CompetitionApi.fetchCompetitions(lang).then(({ competitions }) => {
      setCompetitions(competitions);
    });
  }, [lang]);

  return (
    <CompetitionsProvider competitions={competitions}>
      <Switch>
        <Route component={Tournament} path={`${competitionPath}/:id`} />
        <Route component={Competition} path={`${competitionPath}`} />
      </Switch>
    </CompetitionsProvider>
  );
};

export default TournamentRouter;
